<card-shell
    [config]="{ legacy: true, title: widgetConfig?.widgetTitle | translate, subtitle: widgetConfig?.widgetSubtitle | translate }"
    [status]="status$ | async"
>
    <scale [ranges]="ranges$ | async" [value]="value$ | async" [labels]="labels" />
</card-shell>
